import { getOutlineStyle } from './input';
const getBaseStyle = (props) => {
    const { field } = getOutlineStyle(props);
    return {
        wrapper: {
            transition: 'all 250ms',
            borderRadius: 'base',
            padding: 4,
            ...field,
            _checked: {
                ...field._focus,
            },
        },
        collapse: {
            overflow: props.isChecked ? 'visible' : 'hidden',
        },
    };
};
export default {
    baseStyle: getBaseStyle,
};
//# sourceMappingURL=radio-card.js.map